import React, { useEffect, useContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';

import {
  Box,
  Button,
  TextField,
  InputAdornment,
} from '@mui/material';

import APIS from "../../utils/APIS"
import { setUser } from "../../utils/auth"
import { passwordValidation } from "../account/SettingsPassword"
import { PopupNotifContext } from "../../contexts/PopupNotifContext"

import MyModal from "./MyModal"

import closeIcon from '../../images/closeIcon.svg';
import accountIcon from "../../images/accountIcon.svg"
import simpleArrowIcon from "../../images/simpleArrowIcon.svg"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// S2 : module "Mon compte" porte de THE LAB (MyAccount.js), allege :
//  - textes FR en dur (THE SCAN n'a pas d'i18n)
//  - pas d'ecran "langue" (le back ne persiste pas language)
//  - mot de passe branche sur /theScan/changePassword (attend {password, confirm} ;
//    la route /user/updatePassword de THE LAB n'existe pas dans le back)

const PageContainer = ({ children, onCloseModal, setPage, title, onSave, disabledButton, noButton }) => (
  <>
    <Box sx={{
      display:"flex",
      flexDirection:"row",
      justifyContent:"space-between",
    }}>
      <img
        src={simpleArrowIcon}
        style={{width:"20px", height:"20px", cursor:"pointer", transform:"rotate(180deg)"}}
        onClick={() => { setPage("select") }}
      />
      <Box sx={{
        display:"flex",
        flexDirection:"column",
        alignItems:"center",
        gap:"5px",
        marginBottom:"15px",
      }}>
        <Box sx={{fontSize:"14px", color:"#565656"}}>
          Mon compte
        </Box>
        <Box sx={{fontSize:"17px", color:"text.black"}}>
          {title}
        </Box>
      </Box>
      <img
        src={closeIcon}
        style={{width:"18px", height:"18px", cursor:"pointer"}}
        onClick={onCloseModal}
      />
    </Box>
    <Box sx={{
      marginTop:"20px",
      flex:1,
      display:"flex",
      flexDirection:"column",
    }}>
      <Box sx={{flex:1}}>
        {children}
      </Box>
      {noButton !== true &&
        <Box sx={{paddingTop:"20px"}}>
          <Button
            disabled={disabledButton}
            color="primary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            onClick={onSave}
          >
            Enregistrer
          </Button>
        </Box>
      }
    </Box>
  </>
)

const champLabel = {textTransform:"uppercase", fontSize:"13px", color:"text.black"}

const MyAccountModal = ({ isOpen, onClose, currentUser }) => {

  const { addPopupNotif } = useContext(PopupNotifContext)

  const [page, setPage] = useState("select")

  const [showPassword, setShowPassword] = useState(false)

  const [newName, setNewName] = useState("")
  const [newPoste, setNewPoste] = useState("")
  const [changeNamesSubmitting, setChangeNamesSubmitting] = useState(false)

  const [newPassword, setNewPassword] = useState("")
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
  const [changePasswordSubmitting, setChangePasswordSubmitting] = useState(false)

  useEffect(() => {
    if (currentUser) {
      setNewName(currentUser?.name || "")
      setNewPoste(currentUser?.poste || "")
    }
  }, [currentUser, page])

  useEffect(() => {
    if (isOpen === false) {
      setTimeout(() => { setPage("select") }, 500)
    }
  }, [isOpen])

  const passwordOk =
    newPassword?.length >= 8 &&
    passwordValidation.regex.test(newPassword) &&
    newPassword === newPasswordConfirm

  return (
    <MyModal
      isOpen={isOpen}
      maxWidth="xs"
      onClose={onClose}
      background="white"
    >
      <Box sx={{
        padding:["25px 20px", "30px 25px"],
        display:"flex",
        flexDirection:"column",
        minHeight:"420px",
      }}>
        {page === "select" &&
          <>
            <Box sx={{display:"flex", flexDirection:"column"}}>
              <Box sx={{display:"flex", justifyContent:"flex-end"}}>
                <img
                  src={closeIcon}
                  style={{width:"18px", height:"18px", cursor:"pointer"}}
                  onClick={onClose}
                />
              </Box>
              <Box sx={{
                fontSize:"30px",
                color:"text.black",
                textAlign:"center",
                display:"flex",
                flexDirection:"column",
                alignItems:"center",
                gap:"10px",
              }}>
                <Box sx={{width:"100px"}}>
                  <img src={accountIcon} style={{width:"100%"}}/>
                </Box>
                {currentUser?.name}
                <Box sx={{fontSize:"16px", color:"text.black", textAlign:"center"}}>
                  {currentUser?.poste}
                </Box>
              </Box>
            </Box>
            <Box sx={{marginTop:"45px"}}>
              <Button
                disableRipple
                fullWidth
                onClick={() => { setPage("name") }}
                sx={{
                  fontSize:"16px",
                  color:"text.black",
                  minWidth:0,
                  borderBottom:"1px solid #EFEFEF",
                  justifyContent:"space-between",
                  "&:hover" : {
                    background:"transparent",
                    color:"#565656",
                  }
                }}
                size="small"
              >
                Modifier mes informations
                <KeyboardArrowDownIcon sx={{fontSize:"20px !important", transform:"rotate(-90deg)"}} />
              </Button>
              <Button
                disableRipple
                fullWidth
                onClick={() => { setPage("password") }}
                sx={{
                  fontSize:"16px",
                  color:"text.black",
                  minWidth:0,
                  justifyContent:"space-between",
                  "&:hover" : {
                    background:"transparent",
                    color:"#565656",
                  }
                }}
                size="small"
              >
                Modifier mon mot de passe
                <KeyboardArrowDownIcon sx={{fontSize:"20px !important", transform:"rotate(-90deg)"}} />
              </Button>
            </Box>
          </>
        }
        {page === "name" &&
          <PageContainer
            onCloseModal={onClose}
            setPage={setPage}
            title="Modifier mes informations"
            disabledButton={newName?.trim()?.length < 3 || changeNamesSubmitting}
            onSave={() => {
              setChangeNamesSubmitting(true)
              APIS.updateAccount({name : newName?.trim(), poste : newPoste?.trim()}).then((result) => {
                if (result?.isOk === true) {
                  setUser({...currentUser, name : newName?.trim(), poste : newPoste?.trim()})
                  addPopupNotif({
                    uuid : uuidv4(),
                    text : "Modifications enregistrées",
                    type : "confirmation",
                    removeAfter:5000,
                  })
                } else {
                  addPopupNotif({
                    uuid : uuidv4(),
                    text : "Une erreur est survenue",
                    type : "error",
                    removeAfter:5000,
                  })
                }
                setChangeNamesSubmitting(false)
              })
            }}
          >
            <Box>
              <Box sx={champLabel}>
                Nom et prénom
              </Box>
              <TextField
                fullWidth
                margin="normal"
                name="name"
                type="text"
                value={newName}
                placeholder="ex. Paul Durand"
                onChange={(e) => { setNewName(e.target.value) }}
                variant="outlined"
                sx={{marginTop:"10px", "& .MuiInputBase-input":{color:"black"}}}
              />
            </Box>
            <Box sx={{paddingTop:"15px"}}>
              <Box sx={champLabel}>
                Votre entreprise
              </Box>
              <TextField
                fullWidth
                margin="normal"
                name="poste"
                type="text"
                value={newPoste}
                placeholder="ex. RisingUp"
                onChange={(e) => { setNewPoste(e.target.value) }}
                variant="outlined"
                sx={{marginTop:"10px", "& .MuiInputBase-input":{color:"black"}}}
              />
            </Box>
          </PageContainer>
        }
        {page === "password" &&
          <PageContainer
            onCloseModal={onClose}
            setPage={setPage}
            title="Modifier mon mot de passe"
            disabledButton={!passwordOk || changePasswordSubmitting}
            onSave={() => {
              setChangePasswordSubmitting(true)
              APIS.changePassword({password : newPassword, confirm : newPasswordConfirm}).then((result) => {
                if (result?.message === "changePassword") {
                  setNewPassword("")
                  setNewPasswordConfirm("")
                  addPopupNotif({
                    uuid : uuidv4(),
                    text : "Mot de passe modifié",
                    type : "confirmation",
                    removeAfter:5000,
                  })
                } else {
                  addPopupNotif({
                    uuid : uuidv4(),
                    text : "Une erreur est survenue",
                    type : "error",
                    removeAfter:5000,
                  })
                }
                setChangePasswordSubmitting(false)
              })
            }}
          >
            <Box>
              <Box sx={champLabel}>
                Nouveau mot de passe
              </Box>
              <TextField
                fullWidth
                margin="normal"
                name="newPassword"
                type={showPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value) }}
                variant="outlined"
                placeholder="Nouveau mot de passe"
                helperText={newPassword?.length > 0 && !passwordValidation.regex.test(newPassword) ? passwordValidation.matches : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </InputAdornment>
                  ),
                }}
                sx={{marginTop:"10px", "& .MuiInputBase-input":{color:"black"}}}
              />
            </Box>
            <Box sx={{paddingTop:"15px"}}>
              <Box sx={champLabel}>
                Confirmer le mot de passe
              </Box>
              <TextField
                fullWidth
                margin="normal"
                name="newPasswordConfirm"
                type={showPassword ? "text" : "password"}
                value={newPasswordConfirm}
                onChange={(e) => { setNewPasswordConfirm(e.target.value) }}
                variant="outlined"
                placeholder="Confirmer le mot de passe"
                helperText={newPasswordConfirm?.length > 0 && newPassword !== newPasswordConfirm ? "Les deux mots de passe ne correspondent pas" : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </InputAdornment>
                  ),
                }}
                sx={{marginTop:"10px", "& .MuiInputBase-input":{color:"black"}}}
              />
            </Box>
          </PageContainer>
        }
      </Box>
    </MyModal>
  )
}

export default MyAccountModal
